import React from 'react';

export const FaceSadnessIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
        fill="#FFB02E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.7131 14.5C14.7131 16.8472 12.8103 18.75 10.4631 18.75C8.11592 18.75 6.21313 16.8472 6.21313 14.5C6.21313 12.1528 8.11592 10.25 10.4631 10.25C12.8103 10.25 14.7131 12.1528 14.7131 14.5ZM25.7131 14.5C25.7131 16.8472 23.8103 18.75 21.4631 18.75C19.1159 18.75 17.2131 16.8472 17.2131 14.5C17.2131 12.1528 19.1159 10.25 21.4631 10.25C23.8103 10.25 25.7131 12.1528 25.7131 14.5Z"
        fill="white"
      />
      <path
        d="M6.97423 10.6581C7.11769 10.2277 7.47625 9.55049 8.06915 8.98761C8.65355 8.4328 9.45199 8 10.4999 8C10.776 8 10.9999 7.77614 10.9999 7.5C10.9999 7.22386 10.776 7 10.4999 7C9.1478 7 8.1129 7.5672 7.38064 8.26239C6.65687 8.94951 6.21542 9.77226 6.02555 10.3419C5.93823 10.6039 6.07981 10.887 6.34178 10.9743C6.60375 11.0617 6.88691 10.9201 6.97423 10.6581Z"
        fill="#402A32"
      />
      <path
        d="M13.707 23.7071C13.9863 23.4278 14.7141 23 15.9999 23C17.2274 23 18.0185 23.4329 18.2928 23.7071C18.6833 24.0976 19.3165 24.0976 19.707 23.7071C20.0975 23.3166 20.0975 22.6834 19.707 22.2929C18.9812 21.5671 17.639 21 15.9999 21C14.2856 21 13.0135 21.5722 12.2928 22.2929C11.9023 22.6834 11.9023 23.3166 12.2928 23.7071C12.6833 24.0976 13.3165 24.0976 13.707 23.7071Z"
        fill="#402A32"
      />
      <path
        d="M25.0255 10.6581C24.8821 10.2277 24.5235 9.55049 23.9306 8.98761C23.3462 8.4328 22.5478 8 21.4999 8C21.2237 8 20.9999 7.77614 20.9999 7.5C20.9999 7.22386 21.2237 7 21.4999 7C22.852 7 23.8869 7.5672 24.6191 8.26239C25.3429 8.94951 25.7844 9.77226 25.9742 10.3419C26.0616 10.6039 25.92 10.887 25.658 10.9743C25.396 11.0617 25.1129 10.9201 25.0255 10.6581Z"
        fill="#402A32"
      />
      <path
        d="M13 14.5C13 15.6046 12.1046 16.5 11 16.5C9.89543 16.5 9 15.6046 9 14.5C9 13.3954 9.89543 12.5 11 12.5C12.1046 12.5 13 13.3954 13 14.5Z"
        fill="#402A32"
      />
      <path
        d="M23 14.5C23 15.6046 22.1046 16.5 21 16.5C19.8954 16.5 19 15.6046 19 14.5C19 13.3954 19.8954 12.5 21 12.5C22.1046 12.5 23 13.3954 23 14.5Z"
        fill="#402A32"
      />
      <path
        d="M6 21C6 19.8954 6.89543 19 8 19C9.10457 19 10 19.8954 10 21V24C10 25.1046 9.10457 26 8 26C6.89543 26 6 25.1046 6 24V21Z"
        fill="#3F5FFF"
      />
    </svg>
  );
};
